export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  zone: 'zone1' | 'zone2';
  imageUrl: string;
  imageAlt: string;
  tags: string[];
  author: string;
  publishDate: string;
  updateDate: string;
  readTime: number;
  featured: boolean;
  views: number;
  slug: string;
}

export const categories = [
  {
    id: 'zone1',
    name: '一区精选',
    slug: 'zone1',
    description: '汇聚国产影视剧集与动漫动画优质内容，精挑细选，品质保证，为您呈现最精彩的国产视觉盛宴。',
    icon: 'ri-movie-2-line',
    color: 'accent',
    subCategories: [
      { id: 'zone1-drama', name: '影视剧集', slug: 'zone1-drama' },
      { id: 'zone1-anime', name: '动漫动画', slug: 'zone1-anime' },
      { id: 'zone1-short', name: '短剧精选', slug: 'zone1-short' },
    ],
  },
  {
    id: 'zone2',
    name: '二区精选',
    slug: 'zone2',
    description: '国产综艺娱乐与纪录片内容专区，轻松有趣与深度思考并存，满足您的多元内容需求。',
    icon: 'ri-tv-2-line',
    color: 'secondary',
    subCategories: [
      { id: 'zone2-variety', name: '综艺娱乐', slug: 'zone2-variety' },
      { id: 'zone2-doc', name: '纪录片', slug: 'zone2-doc' },
      { id: 'zone2-talk', name: '访谈节目', slug: 'zone2-talk' },
    ],
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《山河锦绣》—— 一部展现华夏大地壮美风光的史诗巨制',
    excerpt: '这部国产纪录片以全新视角展现中华大地锦绣山河，从雪域高原到江南水乡，从大漠孤烟到碧海蓝天，带您领略祖国大好河山的无穷魅力。',
    content: `<p>《山河锦绣》是一部历时三年拍摄完成的国产大型纪录片，全片以4K超高清画质呈现，摄制组走遍全国三十四个省级行政区，行程超过十万公里。</p>
<p>纪录片分为\"北国风光\"、\"江南烟雨\"、\"西域奇观\"、\"东海明珠\"四个篇章，每个篇章聚焦不同地域的自然景观与人文风貌。从大兴安岭的苍茫林海到桂林山水的诗情画意，从敦煌莫高窟的神秘壁画到鼓浪屿的浪漫风情，每一帧画面都是对中华大地最深情的礼赞。</p>
<p>该片不仅展现了自然景观的壮美，更深入挖掘了各地独特的文化传统与民俗风情。在黑龙江，镜头记录下赫哲族渔猎文化的传承；在云南，展现了傣族泼水节的欢乐场景；在陕西，呈现了安塞腰鼓的磅礴气势。</p>
<p>《山河锦绣》自播出以来广受好评，豆瓣评分高达9.2分，被誉为\"国产纪录片的里程碑之作\"。观众纷纷表示，通过这部纪录片重新认识了祖国的辽阔与美丽，民族自豪感油然而生。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20landscape%20documentary%20scene%2C%20snow%20mountain%20and%20traditional%20village%2C%20golden%20sunset%20light%2C%20cinematic%20aerial%20view%2C%20soft%20warm%20tones%2C%20clean%20simple%20background&width=1200&height=675&seq=article-1-hero&orientation=landscape',
    imageAlt: '山河锦绣纪录片壮美风光',
    tags: ['纪录片', '自然风光', '人文地理', '高分推荐'],
    author: '内容编辑部',
    publishDate: '2026-07-15',
    updateDate: '2026-08-01',
    readTime: 8,
    featured: true,
    views: 128600,
    slug: 'shan-he-jin-xiu',
  },
  {
    id: 'article-2',
    title: '《星辰大海》国产科幻剧集的突破与创新之路',
    excerpt: '从特效制作到剧本打磨，国产科幻剧《星辰大海》如何在有限的预算下，打造出令人惊艳的视觉奇观？深度解析背后的创作故事。',
    content: `<p>国产科幻剧《星辰大海》自开播以来便引发热议，这部由新生代导演执导的作品，在有限预算下打造出了令人惊艳的视觉奇观，被业内称为\"国产科幻的新标杆\"。</p>
<p>该剧讲述了在近未来，人类首次实现星际移民的壮丽故事。剧组在特效制作上采用了全新的虚拟拍摄技术，将实景拍摄与CGI完美融合。美术团队参考了大量航天资料，力求在科学性与观赏性之间找到最佳平衡点。</p>
<p>主演团队更是倾尽全力，为角色进行了长达三个月的体能训练和航天知识学习。剧中精彩的太空行走场景全部由演员在特制装置上完成，真实感十足。</p>
<p>《星辰大海》不仅在国内引发热潮，更在国际科幻圈引起关注。多家海外媒体对这部作品给予高度评价，认为它标志着中国科幻影视产业进入了一个新阶段。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20spaceship%20interior%2C%20astronaut%20looking%20at%20stars%2C%20cinematic%20lighting%2C%20warm%20orange%20and%20teal%20tones%2C%20clean%20minimal%20set%20design&width=1200&height=675&seq=article-2-hero&orientation=landscape',
    imageAlt: '星辰大海科幻剧集场景',
    tags: ['科幻', '国产剧', '特效制作', '热门推荐'],
    author: '内容编辑部',
    publishDate: '2026-07-20',
    updateDate: '2026-07-20',
    readTime: 10,
    featured: true,
    views: 95300,
    slug: 'xing-chen-da-hai',
  },
  {
    id: 'article-3',
    title: '《风味人间》第五季：探寻中国美食背后的故事',
    excerpt: '从街头小吃到宫廷御膳，《风味人间》第五季以美食为线索，串联起中国人最朴素的生活哲学与情感记忆。',
    content: `<p>时隔两年，《风味人间》第五季终于回归。这一季，摄制组将镜头对准了中国各地的街头美食与家庭厨房，以更接地气的视角展现中国人\"吃\"的智慧。</p>
<p>从重庆的麻辣火锅到广州的早茶点心，从东北的酸菜炖粉条到新疆的手抓羊肉，节目组深入全国二十多个城市，记录了上百道地方美食的制作全过程。每一道美食背后，都承载着一方水土的文化记忆与生活哲学。</p>
<p>本季的一大亮点是对\"家常菜\"的深度挖掘。节目组走进普通人家，记录下那些代代相传的家族菜谱，以及藏在一日三餐里的温情故事。这些看似平凡的日常，恰恰是最动人的中国故事。</p>
<p>《风味人间》第五季在延续前作精良制作的风格基础上，更加注重人文关怀与情感表达，被观众称为\"最下饭的纪录片\"。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20street%20food%20market%20at%20night%2C%20steaming%20hot%20dishes%2C%20warm%20ambient%20lighting%2C%20bustling%20atmosphere%2C%20rich%20colors%2C%20clean%20composition&width=1200&height=675&seq=article-3-hero&orientation=landscape',
    imageAlt: '风味人间美食纪录片场景',
    tags: ['纪录片', '美食', '人文', '热门'],
    author: '内容编辑部',
    publishDate: '2026-07-18',
    updateDate: '2026-07-25',
    readTime: 12,
    featured: true,
    views: 156200,
    slug: 'feng-wei-ren-jian-s5',
  },
  {
    id: 'article-4',
    title: '国产动画《长安幻夜》如何重现盛唐风华',
    excerpt: '这部以唐代长安为背景的国产动画，凭借精美的画面和对历史细节的考究还原，成为年度最受期待的国漫作品之一。',
    content: `<p>国产动画电影《长安幻夜》自发布预告片以来便引发广泛关注，这部以盛唐时期长安城为背景的作品，在画面质感和历史细节的还原上达到了国产动画的新高度。</p>
<p>制作团队历时五年精心打磨，美术组查阅了大量唐代文物和历史文献，从建筑形制到人物服饰，从街市场景到宫廷礼仪，每一个细节都力求还原盛唐时期的历史风貌。片中长安城的场景搭建，参考了考古发掘报告和敦煌壁画，再现了这座当时世界最大都市的恢宏气象。</p>
<p>故事围绕一位少年画师在长安城的奇遇展开，融合了历史、奇幻与冒险元素。影片在叙事上突破了传统国漫的套路，既有宏大的世界观构建，又不失细腻的情感表达。</p>
<p>《长安幻夜》在多个国际动画节展映后获得一致好评，被认为是中国动画产业走向成熟的标志性作品。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20city%20at%20night%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20fantasy%20atmosphere%2C%20warm%20golden%20lighting%2C%20artistic%20illustration%20style&width=1200&height=675&seq=article-4-hero&orientation=landscape',
    imageAlt: '长安幻夜动画盛唐场景',
    tags: ['国产动画', '历史', '奇幻', '高分推荐'],
    author: '内容编辑部',
    publishDate: '2026-07-22',
    updateDate: '2026-07-22',
    readTime: 9,
    featured: false,
    views: 87200,
    slug: 'chang-an-huan-ye',
  },
  {
    id: 'article-5',
    title: '《声入人心》第四季：用声音传递力量',
    excerpt: '作为国内顶级音乐竞演节目，《声入人心》第四季以全新的赛制和更丰富的音乐类型，为观众带来一场场视听盛宴。',
    content: `<p>《声入人心》第四季强势回归，本季在保留经典赛制的基础上进行了全面升级。新增的\"跨界合作\"环节让美声、流行、民族、戏曲等多种音乐类型在舞台上碰撞出令人惊喜的火花。</p>
<p>选手阵容同样令人期待。来自全国各大音乐院校的青年才俊齐聚一堂，他们中既有古典音乐科班出身的专业歌手，也有自学成才的原创音乐人。多元化的选手背景为节目注入了丰富的音乐元素。</p>
<p>导师阵容方面，本季邀请到了国际知名歌唱家与国内顶尖音乐制作人共同坐镇，他们在专业点评之外，更注重对选手音乐理念的引导与启迪。</p>
<p>节目播出三周以来，全网话题阅读量已突破十亿，多首改编作品登上音乐平台热门榜单，再次证明了优质音乐内容的强大生命力。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20dramatic%20lighting%2C%20singer%20performing%2C%20grand%20stage%20design%2C%20warm%20spotlight%2C%20elegant%20atmosphere%2C%20clean%20composition&width=1200&height=675&seq=article-5-hero&orientation=landscape',
    imageAlt: '声入人心音乐节目舞台',
    tags: ['音乐综艺', '竞演', '热门节目', '声乐'],
    author: '内容编辑部',
    publishDate: '2026-07-25',
    updateDate: '2026-08-05',
    readTime: 7,
    featured: false,
    views: 113400,
    slug: 'sheng-ru-ren-xin-s4',
  },
  {
    id: 'article-6',
    title: '国产悬疑剧《暗夜追踪》口碑炸裂的幕后解析',
    excerpt: '一部没有流量明星、没有大IP加持的国产悬疑剧，如何凭借扎实的剧本和精湛的演技，成为年度黑马？',
    content: `<p>今年最令人意外的国产剧黑马，非《暗夜追踪》莫属。这部没有顶级流量、没有知名IP加持的悬疑剧，凭借过硬的质量在竞争激烈的暑期档中脱颖而出。</p>
<p>该剧讲述了退休刑警与年轻记者联手追查一桩尘封多年悬案的故事。剧本由曾获金鸡奖最佳编剧的团队操刀，情节环环相扣，反转出人意料，同时又保持了严谨的逻辑自洽性。</p>
<p>在表演方面，老戏骨与新生代演员的碰撞产生了奇妙的化学反应。主演的每一个眼神、每一个微表情都经得起推敲，让人完全沉浸在故事之中。</p>
<p>制作上，剧组在场景和道具上同样用心。为了还原九十年代的氛围，美术组搜集了大量老物件，从BP机到搪瓷缸，每个细节都经得起时代考据。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20noir%20scene%2C%20rainy%20street%20at%20night%2C%20detective%20silhouette%2C%20neon%20reflections%2C%20atmospheric%20cinematic%20lighting%2C%20warm%20amber%20tones&width=1200&height=675&seq=article-6-hero&orientation=landscape',
    imageAlt: '暗夜追踪悬疑剧场景',
    tags: ['悬疑剧', '国产剧', '口碑推荐', '黑马'],
    author: '内容编辑部',
    publishDate: '2026-07-28',
    updateDate: '2026-07-28',
    readTime: 11,
    featured: true,
    views: 189700,
    slug: 'an-ye-zhui-zong',
  },
  {
    id: 'article-7',
    title: '《中国奇谭》第二季：传统故事的现代表达',
    excerpt: '现象级国产动画短片集《中国奇谭》第二季即将上线，八部全新作品将以更丰富的艺术形式演绎中国传统文化。',
    content: `<p>去年引爆全网的国产动画短片集《中国奇谭》宣布第二季定档，八部全新作品涵盖水墨、剪纸、黏土、数字绘画等多种艺术形式，继续探索中国传统故事的现代表达。</p>
<p>第二季在题材选择上更加大胆多元，既有对《山海经》神话的重新演绎，也有对近现代民间传说的创意改编。每部短片都邀请了不同风格的动画导演执掌，确保了视觉风格的丰富性。</p>
<p>其中一部以敦煌壁画为灵感的水墨动画短片尤为引人注目，制作团队在传统水墨技法的基础上融入了现代动画技术，画面流转之间尽显东方美学韵味。</p>
<p>《中国奇谭》制作人表示，第二季将继续坚持\"中国故事、中国美学、中国表达\"的创作理念，用世界通行的动画语言讲述属于中国的精彩故事。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20animation%20style%2C%20mythical%20creatures%2C%20traditional%20Chinese%20art%2C%20ethereal%20misty%20mountains%2C%20elegant%20watercolor%20texture%2C%20soft%20natural%20tones&width=1200&height=675&seq=article-7-hero&orientation=landscape',
    imageAlt: '中国奇谭动画艺术风格',
    tags: ['国产动画', '传统文化', '艺术短片', '期待'],
    author: '内容编辑部',
    publishDate: '2026-07-30',
    updateDate: '2026-07-30',
    readTime: 6,
    featured: false,
    views: 76100,
    slug: 'zhong-guo-qi-tan-s2',
  },
  {
    id: 'article-8',
    title: '《故事里的中国》全新一季：让历史人物鲜活起来',
    excerpt: '这档以戏剧演绎中国历史故事的节目，通过创新的舞台呈现和深度的内容解读，让尘封的历史人物重焕光彩。',
    content: `<p>央视王牌文化节目《故事里的中国》全新一季正式开播，本季选取了十位在中国历史上具有重要影响力的人物，通过戏剧表演与专家解读相结合的方式，带领观众穿越时空，感受历史人物的真实情感与人生抉择。</p>
<p>节目在舞台呈现上进行了大胆创新，采用了沉浸式环形舞台设计，观众席环绕舞台四周，拉近了表演者与观众的距离。灯光和多媒体技术的巧妙运用，让历史场景的转换流畅自然，增强了观感的沉浸感。</p>
<p>首期节目聚焦唐代诗人李白，通过对其诗作《将进酒》《静夜思》等名篇的戏剧化演绎，生动展现了一代诗仙的豪迈与孤独。演员精湛的表演让观众仿佛看到了那个\"仰天大笑出门去\"的李太白。</p>
<p>节目播出后，\"李白\"相关话题迅速登上热搜，年轻观众纷纷表示，这样的文化节目既有深度又不沉闷，让人重新燃起了对传统文化的兴趣。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20theater%20stage%2C%20actor%20in%20ancient%20costume%2C%20dramatic%20lighting%2C%20cultural%20performance%2C%20warm%20golden%20and%20red%20tones%2C%20elegant%20composition&width=1200&height=675&seq=article-8-hero&orientation=landscape',
    imageAlt: '故事里的中国节目舞台',
    tags: ['文化节目', '历史', '戏剧', '央视'],
    author: '内容编辑部',
    publishDate: '2026-08-01',
    updateDate: '2026-08-01',
    readTime: 8,
    featured: false,
    views: 68900,
    slug: 'gu-shi-li-de-zhong-guo',
  },
  {
    id: 'article-9',
    title: '国产自然纪录片《蔚蓝之境》揭秘海洋深处的生命奇迹',
    excerpt: '历时五年，深入四大洋，《蔚蓝之境》以世界级的水下摄影技术，首次全方位展示中国海域及全球海洋的壮丽生命图景。',
    content: `<p>国产大型自然纪录片《蔚蓝之境》经过五年的艰苦拍摄终于与观众见面。摄制组跨越四大洋，潜入深海，用镜头捕捉到了无数令人惊叹的海洋生命瞬间。</p>
<p>从南海珊瑚礁的缤纷世界到北极冰下的神秘生态，从鲸鲨优雅的游弋到磷虾壮观的集群，每一个画面都展现了大自然最纯粹的美。值得一提的是，摄制组首次在中国海域拍摄到了罕见的深海热液喷口生态系统，这一发现具有重要的科学价值。</p>
<p>在制作水准上，《蔚蓝之境》达到了国际一流水平。水下摄影团队使用了最先进的4K超高清设备，配合自主研发的水下稳定装置，确保了画面的极致清晰与流畅。</p>
<p>影片配乐由知名作曲家操刀，将中国传统乐器与交响乐完美融合，营造出大气磅礴又不失细腻的听觉体验，与画面相得益彰。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Underwater%20ocean%20scene%20with%20coral%20reef%20and%20tropical%20fish%2C%20sunlight%20rays%20through%20water%2C%20crystal%20clear%20blue%20water%2C%20vibrant%20marine%20life%2C%20clean%20natural%20lighting&width=1200&height=675&seq=article-9-hero&orientation=landscape',
    imageAlt: '蔚蓝之境海洋纪录片场景',
    tags: ['纪录片', '海洋', '自然', '高分'],
    author: '内容编辑部',
    publishDate: '2026-08-02',
    updateDate: '2026-08-02',
    readTime: 9,
    featured: false,
    views: 104200,
    slug: 'wei-lan-zhi-jing',
  },
  {
    id: 'article-10',
    title: '《笑傲江湖》全新脱口秀赛季：新人与老将的精彩对决',
    excerpt: '国内顶级脱口秀竞演节目《笑傲江湖》新赛季开播，全新的赛制和更加多元的选手阵容，让这个夏天笑料不断。',
    content: `<p>《笑傲江湖》脱口秀大赛新赛季火热开启！本季最大的亮点是引入了\"新老对抗\"赛制，往季优秀选手与新生代脱口秀演员同台竞技，碰撞出令人捧腹的化学反应。</p>
<p>新赛季的选手阵容更加多元化，除了传统的单口喜剧演员外，还加入了漫才组合、即兴喜剧等多种表演形式。选手们来自各行各业，有程序员、外卖骑手、退休教师，他们用独特的视角解构生活，让观众在笑声中思考。</p>
<p>节目在舞台设计上也下足了功夫，采用了更加开放的圆形舞台，拉近了演员与观众的距离，增强了现场互动感。现场观众的笑声和反应被保留在节目中，传递出真实而有感染力的欢乐氛围。</p>
<p>首期节目播出后，多个脱口秀段落在社交媒体上被广泛传播，金句频出，引发了观众对当代生活话题的热烈讨论。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20spotlight%2C%20stand-up%20comedian%20performing%2C%20warm%20atmosphere%2C%20brick%20wall%20background%2C%20intimate%20venue%2C%20soft%20amber%20lighting&width=1200&height=675&seq=article-10-hero&orientation=landscape',
    imageAlt: '笑傲江湖脱口秀舞台',
    tags: ['脱口秀', '综艺', '喜剧', '热门'],
    author: '内容编辑部',
    publishDate: '2026-08-03',
    updateDate: '2026-08-03',
    readTime: 7,
    featured: false,
    views: 132800,
    slug: 'xiao-ao-jiang-hu',
  },
  {
    id: 'article-11',
    title: '国产独立电影《归途》—— 一部关于回家的温暖故事',
    excerpt: '这部制作成本不到五百万的国产独立电影，凭借真挚的情感和细腻的叙事，在各大电影节上斩获多项大奖。',
    content: `<p>国产独立电影《归途》讲述了一位在城市打拼多年的年轻人，在春节前夕踏上回家之路的故事。影片以公路片的叙事结构，串联起一路上的种种际遇，展现了当代中国社会中普通人最真实的情感世界。</p>
<p>影片的导演是一位首次执导长片的青年电影人，他用朴实无华的镜头语言，捕捉到了中国乡村与城市之间的巨大变迁。片中没有刻意的煽情，而是通过一个个看似平常的细节——母亲包的饺子、父亲修理的旧家具、村口老槐树下晒太阳的老人——来唤起观众内心最深处的共鸣。</p>
<p>主演是一位实力派话剧演员，他将角色内心的矛盾与挣扎演绎得淋漓尽致，每一个眼神都饱含情感。影片在国内外多个电影节展映后，观众纷纷表示\"看哭了\"、\"想起了自己的家乡\"。</p>
<p>《归途》证明了，好的电影不一定需要巨额投资和炫目特效，真挚的情感和扎实的叙事才是打动人心的关键。</p>`,
    category: '一区精选',
    categorySlug: 'zone1',
    zone: 'zone1',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rural%20Chinese%20countryside%20at%20sunset%2C%20winding%20road%20through%20fields%2C%20warm%20golden%20light%2C%20simple%20farmhouse%2C%20nostalgic%20atmosphere%2C%20clean%20minimal%20composition&width=1200&height=675&seq=article-11-hero&orientation=landscape',
    imageAlt: '归途独立电影乡村场景',
    tags: ['独立电影', '温情', '获奖', '推荐'],
    author: '内容编辑部',
    publishDate: '2026-08-04',
    updateDate: '2026-08-04',
    readTime: 10,
    featured: false,
    views: 57800,
    slug: 'gui-tu',
  },
  {
    id: 'article-12',
    title: '《舞动中国》新一季：以舞蹈讲述中国故事',
    excerpt: '从古典舞到现代舞，从民族舞到街舞，《舞动中国》以舞蹈为媒介，展现中国文化的多元魅力与时代活力。',
    content: `<p>大型舞蹈竞演节目《舞动中国》全新一季震撼来袭！本季节目以\"用身体讲述中国故事\"为主题，邀请来自全国各地的顶尖舞者，通过不同风格的舞蹈作品诠释丰富多彩的中国文化。</p>
<p>节目中，古典舞选手以敦煌飞天为灵感，用曼妙身姿再现千年壁画的神韵；民族舞团队将苗族的银饰舞与现代编舞理念相结合，创造出令人耳目一新的舞蹈语言；街舞选手则在Breaking中融入中国功夫元素，展现出中西合璧的独特魅力。</p>
<p>值得一提的是，本季特别设置了\"非遗舞蹈\"环节，聚焦那些正在消失的传统民间舞蹈。通过专业舞者的重新编排与演绎，这些沉睡的舞蹈艺术在舞台上重新焕发生机。</p>
<p>节目播出后受到广泛好评，网友们纷纷称赞它\"让舞蹈回归了表达的本质\"，\"看到了中国文化自信的力量\"。</p>`,
    category: '二区精选',
    categorySlug: 'zone2',
    zone: 'zone2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20contemporary%20dance%20performance%20on%20stage%2C%20flowing%20fabric%20and%20dramatic%20lighting%2C%20elegant%20movement%2C%20warm%20and%20rich%20colors%2C%20artistic%20composition&width=1200&height=675&seq=article-12-hero&orientation=landscape',
    imageAlt: '舞动中国舞蹈节目表演',
    tags: ['舞蹈', '综艺', '文化', '热门'],
    author: '内容编辑部',
    publishDate: '2026-08-05',
    updateDate: '2026-08-05',
    readTime: 7,
    featured: false,
    views: 89700,
    slug: 'wu-dong-zhong-guo',
  },
];

export const faqs = [
  {
    question: '国产一区二区精选内容导航平台是什么？',
    answer: '国产一区二区精选内容导航平台是一个专注于国产优质内容的导航与推荐平台。我们将内容按"一区精选"（影视剧集、动漫动画）和"二区精选"（综艺娱乐、纪录片、访谈节目）进行精准分类，帮助用户快速找到感兴趣的国产内容资源。',
  },
  {
    question: '一区和二区的内容有什么区别？',
    answer: '一区精选主要涵盖国产影视剧集、动漫动画、短剧等视听内容；二区精选则聚焦综艺娱乐、纪录片、访谈节目、音乐舞蹈等多元内容。两大分区各具特色，满足不同用户的观看偏好。',
  },
  {
    question: '平台内容多久更新一次？',
    answer: '我们保持每日更新的节奏，持续追踪国产优质内容的最新动态。无论是热播剧集、新上映的电影，还是备受关注的综艺节目，您都能在平台上第一时间获取相关信息。',
  },
  {
    question: '如何在平台上找到我感兴趣的内容？',
    answer: '您可以通过首页的精选推荐浏览热门内容，也可以通过顶部的分类导航直接进入一区精选或二区精选页面。每个分类页面都提供了详细的标签筛选功能，帮助您精准定位感兴趣的内容类型。',
  },
  {
    question: '平台的内容是否免费？',
    answer: '本平台是一个内容导航和推荐平台，所有文章和介绍内容均免费阅读。具体影视内容的观看可能需要前往对应的官方平台或授权渠道进行。',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20simple%20studio%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-1&orientation=squarish',
    role: '影视爱好者',
    content: '国产一区二区的分类方式太方便了！以前找国产好剧要翻好几个平台，现在直接在这里就能看到精选推荐，省时又省力。',
    rating: 5,
  },
  {
    id: 't2',
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20simple%20studio%20lighting%2C%20clean%20neutral%20background%2C%20warm%20smile&width=100&height=100&seq=avatar-2&orientation=squarish',
    role: '内容创作者',
    content: '作为一个内容创作者，我每天都会来这个平台看看最新的国产内容动态。推荐的质量很高，帮我发现了不少好作品。',
    rating: 5,
  },
  {
    id: 't3',
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20simple%20studio%20lighting%2C%20clean%20neutral%20background%2C%20calm%20expression&width=100&height=100&seq=avatar-3&orientation=squarish',
    role: '资深影评人',
    content: '这个平台对国产内容的分类非常专业，一区二区的划分清晰合理。文章质量高，深度解析到位，是我日常获取内容资讯的重要来源。',
    rating: 5,
  },
];